function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TextControls from './textControls';
export default class TreeNodeText extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editing: false
    };
    this.handleAdd = this.handleAdd.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleHoverTrue = this.setHover.bind(this, true);
    this.handleHoverFalse = this.setHover.bind(this, false);
    this.handleChange = this.handleChange.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
  }
  setHover(hover) {
    const {
      onHover
    } = this.props;
    onHover(hover);
  }
  handleAdd(id) {
    const {
      onAdd
    } = this.props;
    onAdd(id);
  }
  handleChange(event) {
    this.setState({
      text: event.target.value
    });
  }
  handleEdit(event, edit = true) {
    const {
      node
    } = this.props;
    this.setState({
      editing: edit,
      text: node.name
    });
  }
  handleRemove() {
    const {
      onRemove,
      node
    } = this.props;
    onRemove(node.id);
  }
  handleSelect(event) {
    const {
      onSelect,
      node
    } = this.props;
    event.stopPropagation();
    onSelect(node);
  }
  handleSave() {
    const {
      onSelect,
      onSave,
      node
    } = this.props;
    const {
      text
    } = this.state;
    let name = JSON.parse(JSON.stringify(text));
    if (name.length === 0) {
      name = 'unset';
    }
    this.handleEdit({}, false);
    onSelect(null);
    onSave(_objectSpread(_objectSpread({}, node), {}, {
      name
    }));
  }
  hoverStyle() {
    const {
      hover
    } = this.props;
    return hover ? {
      backgroundColor: '#f5f5f5',
      cursor: 'pointer'
    } : {};
  }
  render() {
    const {
      node,
      selected,
      enableLinks
    } = this.props;
    const {
      editing,
      text
    } = this.state;
    const displayText = editing ? text : node.name;
    const hoverStyle = this.hoverStyle();
    let {
      name
    } = node;
    if (name.trim().length === 0) {
      name = 'unset';
    }
    if (!node) {
      return null;
    }
    if (enableLinks) {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("a", {
        href: node.href,
        style: hoverStyle
      }, displayText));
    }
    if (selected) {
      return /*#__PURE__*/React.createElement(TextControls, {
        editing: editing,
        hoverStyle: hoverStyle,
        text: displayText,
        onChange: this.handleChange,
        onSave: this.handleSave,
        onEdit: this.handleEdit,
        onRemove: this.handleRemove,
        onAdd: this.handleAdd
      });
    }
    // otherwise, return clickable text.
    return /*#__PURE__*/React.createElement("span", {
      onKeyDown: this.handleSelect,
      role: "link",
      tabIndex: 0,
      className: "t-tn-click-zone",
      onClick: this.handleSelect,
      onMouseEnter: this.handleHoverTrue,
      onMouseLeave: this.handleHoverFalse,
      style: hoverStyle
    }, name);
  }
}
TreeNodeText.propTypes = {
  selected: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
  onHover: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  onAdd: PropTypes.func.isRequired,
  hover: PropTypes.bool.isRequired,
  enableLinks: PropTypes.bool.isRequired,
  node: PropTypes.shape({
    name: PropTypes.string,
    href: PropTypes.string,
    state: PropTypes.string,
    id: PropTypes.string,
    nodeId: PropTypes.number
  }).isRequired
};